// Maps an LSP diagnostic `code` value onto Monaco's `IMarkerData.code`
// projection (a `string | undefined`). Extracted from the inline ternary in
// `SqlMonaco.tsx`'s `onDiagnostics` handler (P1-T13) so the mapping is
// independently testable and reachable from this module's test suite.
//
// LSP diagnostics allow `code` to be a `string`, `number`, or (per LSP
// 3.16) a `{ value, target }` object carrying a link target alongside the
// code. `LanguageServiceDiagnostic['code']` is typed as `string | number`,
// but the raw JSON-RPC payload from SSTS / pgls can still surface the
// object shape or `null` at runtime, so this function accepts `unknown`.
//
// No-fabricated-code constraint: when there is no real code value to report
// (code is `null`/`undefined`, or an object with no `value`), this returns
// `undefined` rather than inventing an empty string.
export function toMarkerCode(code: unknown): string | undefined {
  if (code === null || code === undefined) return undefined;
  if (typeof code === 'object') {
    const value = (code as { value?: unknown }).value;
    return value === undefined ? undefined : String(value);
  }
  return String(code);
}
